module.exports = "<md-checkbox class=\"md-default-theme md-checkbox--icon\" ng-model=$ctrl.thingStarred ng-change=$ctrl.onChange() aria-label=checkbox> <md-icon md-svg-icon=star aria-label=star></md-icon> <span class=\"form-grid__label form-grid__col__label form-grid__col__label--long\"> Starred things <dt-help-icon message-key=help_icon_advanced_search_starred></dt-help-icon> </span> </md-checkbox> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/sensors-and-connectors/components/search/advanced/thing-star/thing-star.html
// module id = wyRe
// module chunks = 1